<template>
  <ReportBaseSelectFilter
    class="time-type-filter"
    label="Time Type"
    placeholder="All types"
    :options="timeTypeOptions"
    query-property="time_types"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportTimeTypeFilter',
  computed: {
    ...mapGetters(['timeTypeOptions']),
  },
};
</script>
